/* VAALBERG · diamond-pro interactive layer.
   Vanilla JS, no deps. Each module guards its own DOM and no-ops if absent. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var cbrt = function (x) { return Math.sign(x) * Math.pow(Math.abs(x), 1 / 3); };

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = $$('[data-reveal]');
    if (!('IntersectionObserver' in window) || !els.length) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Sticky sub-nav + scroll-spy ---------- */
  function initSubnav() {
    var nav = $('[data-subnav]');
    var hero = $('#dpro-media');
    if (!nav || !hero) return;
    var links = $$('[data-spy]', nav);
    var sections = links.map(function (a) { return $(a.getAttribute('href')); }).filter(Boolean);

    function onScroll() {
      var past = hero.getBoundingClientRect().bottom < 60;
      nav.classList.toggle('is-visible', past);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    if ('IntersectionObserver' in window && sections.length) {
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var id = '#' + e.target.id;
          links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === id); });
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      sections.forEach(function (s) { spy.observe(s); });
    }

    // Smooth scroll for every in-page spy link
    $$('[data-spy]').forEach(function (a) {
      a.addEventListener('click', function (ev) {
        var t = $(a.getAttribute('href'));
        if (!t) return;
        ev.preventDefault();
        window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 70, behavior: 'smooth' });
      });
    });
  }

  /* ---------- Mobile sticky bar ---------- */
  function initMobileBar() {
    var bar = $('[data-mobile-bar]');
    var hero = $('#dpro-media');
    if (!bar || !hero) return;
    function onScroll() { bar.classList.toggle('is-visible', hero.getBoundingClientRect().bottom < 0); }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Zoom lens on hero image ---------- */
  function initZoomLens() {
    var stage = $('[data-zoom-stage]');
    if (!stage || window.matchMedia('(hover: none)').matches) return;
    var lens = document.createElement('div');
    lens.className = 'dpro__zoom-lens';
    stage.appendChild(lens);
    var ZOOM = 2.1;

    function activeImg() {
      var pane = $('.dmv__pane--active', stage) || stage;
      return pane.querySelector('img.dmv__photo') || stage.querySelector('img.dmv__photo');
    }
    stage.addEventListener('mousemove', function (e) {
      var img = activeImg();
      if (!img || !img.complete || !img.naturalWidth) { lens.style.display = 'none'; return; }
      var r = img.getBoundingClientRect();
      var x = e.clientX - r.left, y = e.clientY - r.top;
      if (x < 0 || y < 0 || x > r.width || y > r.height) { lens.style.display = 'none'; return; }
      lens.style.display = 'block';
      lens.style.backgroundImage = 'url(' + img.currentSrc + ')';
      lens.style.backgroundSize = (r.width * ZOOM) + 'px ' + (r.height * ZOOM) + 'px';
      var lw = lens.offsetWidth / 2, lh = lens.offsetHeight / 2;
      var sx = (img.offsetLeft || 0), sy = (img.offsetTop || 0);
      lens.style.left = (sx + x - lw) + 'px';
      lens.style.top = (sy + y - lh) + 'px';
      lens.style.backgroundPosition = '-' + (x * ZOOM - lw) + 'px -' + (y * ZOOM - lh) + 'px';
    });
    stage.addEventListener('mouseleave', function () { lens.style.display = 'none'; });
  }

  /* ---------- Fullscreen lightbox ---------- */
  function initFullscreen() {
    var btn = $('[data-fullscreen]');
    var stage = $('[data-zoom-stage]');
    if (!btn || !stage) return;
    btn.addEventListener('click', function () {
      var img = stage.querySelector('.dmv__pane--active img') || stage.querySelector('img.dmv__photo, img.dmv__spin-img');
      if (!img) return;
      var ov = document.createElement('div');
      ov.className = 'dpro__modal';
      ov.style.background = 'rgba(20,16,14,.92)';
      ov.innerHTML = '<div class="dpro__modal-backdrop"></div>';
      var big = document.createElement('img');
      big.src = img.currentSrc || img.src;
      big.style.cssText = 'position:relative;z-index:1;max-width:92vw;max-height:90vh;border-radius:10px;box-shadow:0 20px 60px rgba(0,0,0,.5)';
      ov.appendChild(big);
      document.body.appendChild(ov);
      var close = function () { ov.remove(); document.removeEventListener('keydown', esc); };
      var esc = function (e) { if (e.key === 'Escape') close(); };
      ov.addEventListener('click', close);
      document.addEventListener('keydown', esc);
    });
  }

  /* ---------- Fit the loupe360 video (match the player's W/H to the frame size) ---------- */
  function initVideoFit() {
    var box = $('.dmv__video'); if (!box) return;
    var frame = box.querySelector('iframe'); if (!frame) return;
    var dmv = $('.dmv');
    // loupe360's diamond viewer (.aws_wrapper) is a FIXED 700×700 box centred on
    // a white page. Requesting a larger canvas leaves white padding around it, so
    // we pin the iframe to 700 (= the viewer) and scale it to fill the frame from
    // the top-left → the viewer fills the card, no white, diamond centred.
    var BASE = 700;
    frame.setAttribute('scrolling', 'no');
    var cur = frame.getAttribute('src') || '';
    var next = cur.replace(/\/video\/\d+\/\d+/, '/video/' + BASE + '/' + BASE);
    if (next && next !== cur) frame.setAttribute('src', next);
    frame.style.width = BASE + 'px';
    frame.style.height = BASE + 'px';
    function fit() {
      var w = box.clientWidth || (dmv ? dmv.clientWidth : 0);
      if (!w) return;
      box.style.setProperty('--dmv-vscale', (w / BASE).toFixed(4));
    }
    fit();
    if ('ResizeObserver' in window && dmv) { new ResizeObserver(fit).observe(dmv); }
    // Re-fit when the Video tab becomes active (pane was display:none → width 0).
    $$('.dmv__tab').forEach(function (tab) { tab.addEventListener('click', function () { setTimeout(fit, 60); }); });
  }

  /* ---------- 4C explorer ---------- */
  var COLOR_ORDER = 'DEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  var CLARITY_ORDER = ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'I1', 'I2', 'I3'];
  var CUT_MAP = { EXCELLENT: 100, EX: 100, IDEAL: 100, 'VERY GOOD': 80, VG: 80, GOOD: 58, G: 58, FAIR: 40, F: 40, POOR: 20, P: 20 };

  function caratMeaning(c) {
    if (c < 0.7) return 'a delicate, understated size';
    if (c < 1.2) return 'a classic, balanced size';
    if (c < 2) return 'a confident size — clearly visible on the hand';
    return 'a true statement size';
  }
  function colorMeaning(g) {
    var i = COLOR_ORDER.indexOf(g.toUpperCase());
    if (i <= 2) return 'In the colourless range — no warmth visible to the eye, even set in white metal.';
    if (i <= 6) return 'Near-colourless — face-up white; any warmth is invisible without lab comparison.';
    return 'A warmer tone that pairs beautifully with yellow and rose gold.';
  }
  function clarityMeaning(g) {
    var i = CLARITY_ORDER.indexOf(g.toUpperCase());
    if (i <= 1) return 'Flawless to internally flawless — no inclusions even under 10× magnification.';
    if (i <= 3) return 'Very, very slight inclusions — invisible to the naked eye and hard to find under a loupe.';
    if (i <= 5) return 'Eye-clean — no inclusions visible without magnification.';
    return 'Inclusions may be visible on close inspection; chosen for value.';
  }

  // Short one-liners for the 4C cards. The template used to hard-code these, so
  // EVERY stone claimed "a confident, clearly visible size", "Colourless to the eye"
  // and "No inclusions visible unaided" — false on 584 pages (under 0.7ct), 8 (colour
  // I+) and 420 (SI/I clarity), and contradicted by the expanded panel right below.
  function caratHint(c) {
    if (!isFinite(c) || c <= 0) return '';
    if (c < 0.7) return 'A delicate, understated size';
    if (c < 1.2) return 'A classic, balanced size';
    if (c < 2) return 'A confident, clearly visible size';
    return 'A true statement size';
  }
  function colorHint(g) {
    var i = COLOR_ORDER.indexOf(String(g).toUpperCase());
    if (i < 0) return '';
    if (i <= 2) return 'Colourless to the eye';
    if (i <= 6) return 'Near-colourless, face-up white';
    return 'A warm tone, lovely in yellow gold';
  }
  function clarityHint(g) {
    var i = CLARITY_ORDER.indexOf(String(g).toUpperCase());
    if (i < 0) return '';
    if (i <= 1) return 'No inclusions even under 10x';
    if (i <= 3) return 'Invisible to the naked eye';
    if (i <= 5) return 'No inclusions visible unaided';
    return 'Inclusions visible on close inspection';
  }
  function cutHint(g) {
    var k = String(g || '').toUpperCase();
    if (!k || k === '—' || k === 'NOT GRADED') return 'Not graded on fancy shapes';
    if (CUT_MAP[k] >= 100) return 'Maximum light return & sparkle';
    if (CUT_MAP[k] >= 80) return 'Strong light return';
    return 'A softer, gentler sparkle';
  }

  function buildScale(type, grade) {
    var pct = 0, order, idx, labels, track = '';
    if (type === 'color') {
      order = COLOR_ORDER; idx = order.indexOf(grade.toUpperCase());
      pct = idx < 0 ? 0 : (idx / (order.length - 1)) * 100;
      labels = '<span>D · colourless</span><span>Z · light</span>';
      track = 'dpro__scale-track--color';
      return scaleHtml(track, pct, labels, grade + ' on the D–Z scale');
    }
    if (type === 'clarity') {
      order = CLARITY_ORDER; idx = order.indexOf(grade.toUpperCase());
      pct = idx < 0 ? 0 : (idx / (order.length - 1)) * 100;
      labels = '<span>FL</span><span>I3</span>';
      return scaleHtml('', pct, labels, grade + ' clarity', true);
    }
    return '';
  }
  function scaleHtml(trackClass, pct, labels, cur, withFill) {
    return '<div class="dpro__scale">' +
      '<div class="dpro__scale-track ' + trackClass + '">' +
      (withFill ? '<div class="dpro__scale-fill" data-fill></div>' : '') +
      '<div class="dpro__scale-marker" data-marker></div></div>' +
      '<div class="dpro__scale-labels">' + labels + '</div>' +
      '<span class="dpro__scale-cur">' + cur + '</span></div>';
  }
  function meterHtml(pct, cur) {
    return '<div class="dpro__scale"><div class="dpro__scale-track"><div class="dpro__scale-fill" data-fill></div></div>' +
      '<div class="dpro__scale-labels"><span>Less light</span><span>Maximum sparkle</span></div>' +
      '<span class="dpro__scale-cur">' + cur + '</span></div>';
  }

  function initFourCs() {
    var wrap = $('[data-4cs]'); var panel = $('[data-c-panel]');
    if (!wrap || !panel) return;
    var cards = $$('.dpro__c', wrap);
    var sizeSec = $('.dpro__size');
    var carat = sizeSec ? parseFloat(sizeSec.dataset.carat) : parseFloat($('.dpro__c[data-c="carat"] .dpro__c-v').textContent);

    // Replace the template's fixed hints with ones that describe THIS stone.
    cards.forEach(function (c) {
      var hint = c.querySelector('.dpro__c-hint'); if (!hint) return;
      var g = c.dataset.grade || '', t = c.dataset.c, txt = '';
      if (t === 'carat') txt = caratHint(carat);
      else if (t === 'color') txt = colorHint(g);
      else if (t === 'clarity') txt = clarityHint(g);
      else if (t === 'cut') txt = cutHint(g);
      if (txt) hint.textContent = txt;
    });

    function close() { cards.forEach(function (c) { c.classList.remove('is-active'); c.setAttribute('aria-expanded', 'false'); });
      panel.style.height = panel.scrollHeight + 'px';
      requestAnimationFrame(function () { panel.style.height = '0px'; });
      setTimeout(function () { panel.hidden = true; panel.innerHTML = ''; panel.style.height = ''; }, 260); }

    function open(card) {
      var type = card.dataset.c, grade = card.dataset.grade || '', html = '', title = '', body = '';
      if (type === 'carat') { title = 'Carat · ' + carat;
        body = '<p>This stone is ' + caratMeaning(carat) + '.</p>';
        html = '<div class="dpro__scale"><div class="dpro__scale-track"><div class="dpro__scale-fill" data-fill></div><div class="dpro__scale-marker" data-marker></div></div><div class="dpro__scale-labels"><span>0.3ct</span><span>3ct+</span></div><span class="dpro__scale-cur">' + carat + ' carat</span></div>';
        card.__pct = Math.min(100, (carat / 3) * 100);
      } else if (type === 'color') { title = 'Colour · ' + grade;
        body = '<p>' + colorMeaning(grade) + '</p>'; html = buildScale('color', grade);
        card.__pct = (COLOR_ORDER.indexOf(grade.toUpperCase()) / (COLOR_ORDER.length - 1)) * 100;
      } else if (type === 'clarity') { title = 'Clarity · ' + grade;
        body = '<p>' + clarityMeaning(grade) + '</p>'; html = buildScale('clarity', grade);
        card.__pct = (CLARITY_ORDER.indexOf(grade.toUpperCase()) / (CLARITY_ORDER.length - 1)) * 100;
      } else { title = 'Cut · ' + grade;
        var ungraded = !CUT_MAP[String(grade).toUpperCase()];
        var pct = CUT_MAP[String(grade).toUpperCase()] || 90;
        // IGI/GIA issue a cut grade for round brilliants only — claiming one on a
        // fancy shape invents a grading the certificate does not contain.
        body = ungraded
          ? '<p>Cut decides how much light comes back as sparkle. Laboratories issue a cut grade for round brilliants only, so fancy shapes like this one are graded on polish and symmetry instead.</p>'
          : '<p>Cut decides how much light comes back as sparkle. ' + (pct >= 100 ? 'Excellent is the top grade — the brilliance you actually see.' : 'A solid grade with good light return.') + '</p>';
        html = ungraded ? '' : meterHtml(pct, grade + ' cut'); card.__pct = pct;
      }
      panel.innerHTML = '<div class="dpro__c-panel-inner"><h3>' + title + '</h3>' + body + html + '</div>';
      panel.hidden = false;
      var h = panel.scrollHeight;
      panel.style.height = '0px';
      requestAnimationFrame(function () { panel.style.height = h + 'px'; });
      panel.style.transition = 'height .28s cubic-bezier(.22,.61,.36,1)';
      setTimeout(function () { panel.style.height = 'auto'; }, 300);
      // animate scale fill + marker
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        var fill = $('[data-fill]', panel), marker = $('[data-marker]', panel);
        if (fill) fill.style.width = card.__pct + '%';
        if (marker) marker.style.left = card.__pct + '%';
      }); });
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        var wasActive = card.classList.contains('is-active');
        cards.forEach(function (c) { c.classList.remove('is-active'); c.setAttribute('aria-expanded', 'false'); });
        if (wasActive) { close(); return; }
        card.classList.add('is-active'); card.setAttribute('aria-expanded', 'true');
        panel.style.transition = ''; open(card);
      });
    });
  }

  /* ---------- Size studio ----------
     Single mm-scaled SVG (viewBox in millimetres): the finger (~17 mm) and the
     diamond live in one coordinate system, so the stone is always TRUE to size.
     We scale only the [data-gem-shape] group; no pixel-per-mm juggling. */
  function initSizeStudio() {
    var sec = $('.dpro__size'); if (!sec) return;
    var gem = $('[data-gem-shape]', sec), readout = $('[data-size-readout]', sec);
    var slider = $('[data-size-slider]', sec), handToggle = $('[data-hand-toggle]', sec);
    var handEls = $$('[data-hand]', sec);
    var stoneCarat = parseFloat(sec.dataset.carat) || 1;
    var baseLen = parseFloat(sec.dataset.length) || 0, baseWid = parseFloat(sec.dataset.width) || 0;

    function dims(c) {
      if (baseLen && baseWid) { var f = cbrt(c / stoneCarat); return [baseLen * f, baseWid * f]; }
      var d = 6.5 * cbrt(c); return [d, d];
    }
    function render(c) {
      var d = dims(c), len = d[0], wid = d[1];
      // Unit diamond is drawn in a 10-unit (=10 mm) box; viewBox is in mm, so
      // scaling by mm/10 renders it at the real size on the finger.
      gem.setAttribute('transform', 'translate(28 43) scale(' + (wid / 10).toFixed(3) + ' ' + (len / 10).toFixed(3) + ')');
      var isThis = Math.abs(c - stoneCarat) < 0.02;
      readout.innerHTML = '<strong>' + (Math.round(c * 100) / 100) + 'ct</strong> · ' + len.toFixed(1) + ' × ' + wid.toFixed(1) + ' mm' + (isThis ? ' — <strong>this stone</strong>' : '');
      $$('[data-carat-preset]', sec).forEach(function (b) { b.classList.toggle('is-active', Math.abs(parseFloat(b.dataset.caratPreset) - c) < 0.02); });
    }
    function setHand(on) { handEls.forEach(function (el) { el.style.display = on ? '' : 'none'; }); }
    slider.addEventListener('input', function () { render(parseFloat(slider.value)); });
    $$('[data-carat-preset]', sec).forEach(function (b) { b.addEventListener('click', function () { slider.value = b.dataset.caratPreset; render(parseFloat(slider.value)); }); });
    if (handToggle) { setHand(handToggle.checked); handToggle.addEventListener('change', function () { setHand(handToggle.checked); }); }
    var reset = $('[data-size-reset]', sec); if (reset) reset.addEventListener('click', function () { slider.value = stoneCarat; render(stoneCarat); });
    render(stoneCarat);
  }

  /* ---------- Certificate modal ---------- */
  function initCertModal() {
    var modal = $('[data-modal="cert"]'); if (!modal) return;
    var frame = $('[data-cert-frame]', modal), openLink = $('[data-cert-open]', modal);
    function open(url) { if (frame) frame.src = url; if (openLink) openLink.href = url; modal.hidden = false; document.body.style.overflow = 'hidden'; }
    function close() { modal.hidden = true; document.body.style.overflow = ''; if (frame) frame.src = ''; }
    $$('[data-open-cert]').forEach(function (b) { b.addEventListener('click', function () { open(b.dataset.openCert); }); });
    $$('[data-modal-close]', modal).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  }

  /* ---------- Contact drawer ---------- */
  function initDrawer() {
    var drawer = $('[data-drawer="contact"]'); if (!drawer) return;
    function open() { drawer.hidden = false; document.body.style.overflow = 'hidden'; }
    function close() { drawer.hidden = true; document.body.style.overflow = ''; }
    $$('[data-open-drawer="contact"]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
  }

  /* ---------- Toast ---------- */
  function toast(msg, linkText, linkHref) {
    var t = $('[data-toast]'); if (!t) return;
    if (linkText && linkHref) {
      t.innerHTML = '<span class="dpro__toast-msg"></span><a class="dpro__toast-link" href="' + linkHref + '"></a>';
      t.querySelector('.dpro__toast-msg').textContent = msg + ' ';
      t.querySelector('.dpro__toast-link').textContent = linkText;
    } else {
      t.textContent = msg;
    }
    t.classList.add('is-visible');
    clearTimeout(t.__h); t.__h = setTimeout(function () { t.classList.remove('is-visible'); }, linkText ? 5000 : 2600);
  }

  // Broadcast's header cart bubble (<cart-count>) does not listen to our events,
  // so after an AJAX add we refresh it from /cart.js ourselves — this is the
  // "nothing happened" fix. Also nudge Broadcast's own components for the drawer.
  function refreshCartUI() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count;
        document.querySelectorAll('cart-count, [data-cart-count]').forEach(function (el) {
          el.setAttribute('data-cart-count', n);
          el.textContent = n;
          if (el.classList) el.classList.toggle('is-empty', n === 0);
        });
        try {
          if (window.publish && window.theme && window.theme.PUB_SUB_EVENTS) {
            window.publish(window.theme.PUB_SUB_EVENTS.cartUpdate, { source: 'diamond-pro', cartData: cart });
          }
        } catch (e) { /* best-effort */ }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }).catch(function () { /* count refresh is best-effort */ });
  }
  function cartUrl() {
    return (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
  }

  // Broadcast's cart drawer content is server-rendered and stale after an AJAX
  // add (item only shows after a full reload). We re-render its section via
  // Shopify's Section Rendering API and swap the drawer's inner HTML in place
  // (keeping the <cart-drawer> element so the header's open handler still works).
  function drawerSectionId() {
    var d = document.querySelector('cart-drawer');
    var w = d && d.closest && d.closest('[id^="shopify-section-"]');
    if (w) return w.id.replace('shopify-section-', '');
    // Broadcast can relocate <cart-drawer> out of its section wrapper — fall back
    // to locating the section by its type so we still request a re-render.
    var byType = document.querySelector('[data-section-type="cart-drawer"]');
    var wrap = byType && byType.closest && byType.closest('[id^="shopify-section-"]');
    return wrap ? wrap.id.replace('shopify-section-', '') : null;
  }
  // Swap the WHOLE <cart-drawer> element for the freshly server-rendered one.
  // innerHTML-only left Broadcast's `is-empty` class + stale internal state on the
  // live element, so opening the drawer showed "Your Cart is Empty" (and hid the
  // checkout button) after the first add from an empty cart. replaceWith brings the
  // correct class + line items and re-runs the element's connectedCallback, which
  // re-initialises from the (now non-empty) server cart.
  function injectDrawer(sections, sid) {
    if (!sid || !sections || !sections[sid]) return false;
    var live = document.querySelector('cart-drawer');
    if (!live) return false;
    var fresh;
    try { fresh = new DOMParser().parseFromString(sections[sid], 'text/html').querySelector('cart-drawer'); }
    catch (e) { return false; }
    if (!fresh) return false;
    try { live.replaceWith(fresh); }
    catch (e) { try { live.className = fresh.className; live.innerHTML = fresh.innerHTML; } catch (e2) { /* best-effort */ } }
    return true;
  }
  function openDrawer() {
    try {
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.openCartDrawer === 'function') { d.openCartDrawer(); return true; }
    } catch (e) { /* best-effort */ }
    return false;
  }

  /* ---------- AJAX add to cart ---------- */
  function initCart() {
    var root = $('.dpro'); if (!root) return;
    var variantId = root.dataset.variantId;
    var form = $('[data-cart-form]');
    var mainBtn = $('[data-add-main]');

    function add(btn) {
      // The spinner alone left the button clickable: a second tap (or the buy box
      // plus the mobile bar, both [data-add]) posted twice and the inventory-1
      // rejection overwrote "Added to your bag" with "already in your bag".
      if (btn) { if (btn.disabled) return; btn.disabled = true; btn.classList.add('is-loading'); }
      var sid = drawerSectionId();
      var body = { items: [{ id: variantId, quantity: 1 }] };
      if (sid) body.sections = [sid]; // ask Shopify to re-render the cart drawer
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
          if (!res.ok) {
            // inventory=1 stones: a 2nd add is rejected — say so kindly, still show the bag.
            var maxed = res.d && /maximum quantity/i.test(res.d.description || '');
            toast(maxed ? 'This one-of-a-kind stone is already in your bag.'
                        : (res.d && res.d.description ? res.d.description : 'Could not add to cart'),
                  'View bag', cartUrl());
            refreshCartUI();
            return;
          }
          if (res.d.sections) injectDrawer(res.d.sections, sid); // drawer now shows the item, no reload
          openDrawer(); // surface the item immediately (mirrors Broadcast's native open-on-add)
          if (mainBtn) { mainBtn.classList.add('is-done'); var l = $('.dpro__btn-label', mainBtn); var old = l ? l.textContent : ''; if (l) l.textContent = '✓ Added'; setTimeout(function () { mainBtn.classList.remove('is-done'); if (l) l.textContent = old; }, 2000); }
          refreshCartUI();
          toast('✓ Added to your bag', 'View bag', cartUrl());
        }).catch(function () { if (btn) btn.classList.remove('is-loading'); toast('Network error — please retry'); });
    }
    // Bind the MAIN button's CLICK directly. The buy-box <form> gets re-parented
    // by cart apps / Google Analytics' _gl linker, which can leave the submit
    // button OUTSIDE the form — then a 'submit' event never fires and the old
    // form-submit-only binding did nothing. A direct click handler (preventDefault
    // also cancels any in-form native submit, so no double-add) works regardless.
    if (mainBtn) mainBtn.addEventListener('click', function (e) { e.preventDefault(); add(mainBtn); });
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(mainBtn); }); // keyboard-Enter fallback
    $$('[data-add]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); add(b); }); });
  }

  /* ---------- Similar carousel ---------- */
  function initCarousel() {
    var track = $('[data-carousel-track]'); if (!track) return;
    var prev = $('[data-carousel-prev]'), next = $('[data-carousel-next]');
    function step() { return Math.max(240, track.clientWidth * 0.7); }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  }

  function boot() {
    initReveal(); initSubnav(); initMobileBar(); initZoomLens(); initFullscreen(); initVideoFit();
    initFourCs(); initSizeStudio(); initCertModal(); initDrawer(); initCart(); initCarousel();
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
